module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (244).b3bf2720.jpg";